<template>
    <vx-styled-card
        collapseAction
        leftBorderSize="0"
        color="primary"
        noRadius
        :cardBorder="false"
        noShadow
        class="notification-card"
    >
        <template slot="title">
            <div class="flex justify-start">
                <img :src="sampleIcon" height="42" />
                <h4 class="ml-3">Grouped Notification</h4>
            </div>
        </template>

        <notification-item
            class="pl-2"
            v-for="(notification, index) in notifications"
            :key="index"
            :item="notification"
            :showIcon="false"
        />
    </vx-styled-card>
</template>

<script>
import NotificationItem from './NotificationItem.vue'
export default {
    name: 'notification-group-item',
    components: {
        NotificationItem
    },
    props: {
        notifications: {
            type: Array,
            default: () => []
        },
        groupIcon: {
            type: String
        }
    },
    data() {
        return {
            sampleIcon: require('../../../assets/images/leaderboard/1st.png')
        }
    }
}
</script>

<style lang="scss" scoped>
.notification-card {
    ::v-deep .vx-card__body {
        padding-left: 0.6rem !important;
        padding-right: 0.2rem !important;
        padding-bottom: 0rem !important;
    }
    ::v-deep .vx-card__header {
        padding-left: 0.6rem !important;
    }
}
</style>
